import { render, staticRenderFns } from "./business_ownership.vue?vue&type=template&id=376fd26c&scoped=true"
import script from "./business_ownership.vue?vue&type=script&lang=js"
export * from "./business_ownership.vue?vue&type=script&lang=js"
import style0 from "./business_ownership.vue?vue&type=style&index=0&id=376fd26c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376fd26c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376fd26c')) {
      api.createRecord('376fd26c', component.options)
    } else {
      api.reload('376fd26c', component.options)
    }
    module.hot.accept("./business_ownership.vue?vue&type=template&id=376fd26c&scoped=true", function () {
      api.rerender('376fd26c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_org/associated/business_ownership/business_ownership.vue"
export default component.exports